import { render, staticRenderFns } from "./DashboardComponentForm.vue?vue&type=template&id=52275dd1&"
import script from "./DashboardComponentForm.vue?vue&type=script&lang=js&"
export * from "./DashboardComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports